import { render, staticRenderFns } from "./ZubutImage.vue?vue&type=template&id=5bf74e6d&scoped=true&"
import script from "./ZubutImage.vue?vue&type=script&lang=js&"
export * from "./ZubutImage.vue?vue&type=script&lang=js&"
import style0 from "./ZubutImage.vue?vue&type=style&index=0&id=5bf74e6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf74e6d",
  null
  
)

export default component.exports